export default {
      id: "revoke-card-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite.svg#revoke-card",
      toString: function () {
        return this.url;
      }
    }